import { DoctorV2, LocationV2, OfferingV2, PartnerV2 } from '@lib/core/models/partners.interface';

export interface PartnerState {
  partnersList: {
    filter: PartnersFilter;
    pageSize: number;
    continuationToken: string;
    data: PartnerV2[];
    loading: boolean;
  };
  currentPartner: {
    data: PartnerV2 | null;
    loading: boolean;
  };
  locationsList: {
    filter: LocationsFilter;
    pageSize: number;
    continuationToken: string;
    data: LocationV2[];
    loading: boolean;
  };
  currentLocation: {
    data: LocationV2 | null;
    loading: boolean;
  };
  doctorsList: {
    filter: DoctorsFilter;
    pageSize: number;
    continuationToken: string;
    data: DoctorV2[];
    loading: boolean;
  };
  currentDoctor: {
    data: DoctorV2 | null;
    loading: boolean;
  };
  offeringsList: {
    filter: OfferingsFilter;
    pageSize: number;
    continuationToken: string;
    data: OfferingV2[];
    loading: boolean;
  };
  currentOffering: {
    data: OfferingV2 | null;
    loading: boolean;
  };
}

export interface PartnersFilter {
  search: string;
  type: PartnerIntegrationTypeFilter;
  status: PartnerStatusFilter;
  availability: PartnerAvailabilityFilter;
  importStatus: PartnerImportStatusFilter;
}

export enum PartnerIntegrationTypeFilter {
  All = 'All',
  Integration = 'Integration',
  Manual = 'Manual',
}

export enum PartnerStatusFilter {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum PartnerAvailabilityFilter {
  All = 'All',
  Available = 'Available',
  Unavailable = 'Unavailable',
}

export enum PartnerImportStatusFilter {
  All = 'All',
  Synced = 'Synced',
  Orphaned = 'Orphaned',
  HasConflicts = 'HasConflicts',
}

export interface LocationsFilter {
  search: string;
  type: PartnerIntegrationTypeFilter;
  status: PartnerStatusFilter;
  availability: PartnerAvailabilityFilter;
  importStatus: PartnerImportStatusFilter;
}

export interface DoctorsFilter {
  search: string;
  type: PartnerIntegrationTypeFilter;
  status: PartnerStatusFilter;
  availability: PartnerAvailabilityFilter;
  importStatus: PartnerImportStatusFilter;
}

export interface OfferingsFilter {
  search: string;
  type: PartnerIntegrationTypeFilter;
  status: PartnerStatusFilter;
  availability: PartnerAvailabilityFilter;
  importStatus: PartnerImportStatusFilter;
  mappedOnly: boolean;
}
